import { useCallback } from 'react'
import {createContext, useState} from 'react'
import * as THREE from 'three'


export const GeometryContext = createContext({
    boxGeometry: null,
    floor1Material:null,
    floor2Material:null,
    obstacleMaterial:null,
    wallMaterial:null,
    blocksCount: 3,
    phase: 'ready',
    onStart: ()=>{},
    onRestart: ()=>{},
    onEnd: ()=>{},
    currentPhase: ()=>{},
    funcTrigger: ()=>{},
})

const GeometryContextProvider = ({children}) =>{
    const boxGeometry = new THREE.BoxGeometry(1,1,1)
    const floor1Material = new THREE.MeshStandardMaterial({color: '#111111', metalness: 0, roughness: 0})
    const floor2Material = new THREE.MeshStandardMaterial({color: '#222222', metalness: 0, roughness: 0})
    const obstacleMaterial = new THREE.MeshStandardMaterial({color: '#ff0000', metalness: 0, roughness: 1})
    const wallMaterial = new THREE.MeshStandardMaterial({color: '#887777', metalness: 0, roughness: 0})

    const [phase, setPhase] = useState('ready')

    const getCurrentPhase = () =>{
        return phase
    }

    const start = ()=>{
        if(phase === 'ready'){
            setPhase((prevPhase)=>prevPhase = 'playing')
        }
       
    }
    const restart = ()=>{
        if(phase === 'playing' || phase === 'ended'){
            setPhase((prevPhase)=>prevPhase = 'ready')
            console.log('From Store ===', phase)
        }
       
    }
    const end = ()=>{
        if(phase === 'playing'){
            setPhase((prevPhase)=>prevPhase = 'ended')
        }
        
    }
    const triggerFunc = useCallback(() =>{
        console.log('function trigger')
    },[])

    const geometryContext = {
        boxGeometry: boxGeometry,
        floor1Material,
        floor2Material,
        obstacleMaterial,
        wallMaterial,
        blocksCount: 3,
        onStart: start,
        onRestart: restart,
        onEnd: end,
        phase: phase,
        currentPhase: getCurrentPhase,
        funcTrigger:triggerFunc
    }

    return (
        <GeometryContext.Provider value={geometryContext}>
            {children}
        </GeometryContext.Provider> 
    )
}


export default GeometryContextProvider